import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import Header from "../components/headerComp";
import Menu from "../components/menuComp";
import Footer from "../components/footerComp";
import ProductCard from "../components/productCard";

const NSDetailsPage = () => {
  const { nsCode } = useParams();
  const [matchingItems, setMatchingItems] = useState([]);
  const navigate = useNavigate();
  const [nsGroup, setNsGroup] = useState(null);

  useEffect(() => {

  // Load the catalog products
  fetch("/items.json?v=2")
    .then((response) => response.json())
    .then((data) => {
      const results = data.filter(
        (item) => item.vendorPartNumber?.trim() === nsCode
      );

      setMatchingItems(results);
    });

  // Load the NS group information
  fetch("/nsGroups.json")
    .then((response) => response.json())
    .then((data) => {
      const group = data.find(
        (group) => group.nsCode === nsCode
      );

      setNsGroup(group);
    });

}, [nsCode]);

  return (
  <div className="home-container">
    <Header />
    <Menu />

    <main className="flex-grow-1">
      <Container className="py-4 pb-5">
        <Button
          variant="danger"
          className="mb-4"
          onClick={() => navigate(-1)}
        >
          ← Back
        </Button>

        {/* NS Code Heading */}
        <div className="text-center mb-5">
          <p className="text-uppercase text-muted fw-semibold mb-1">
            NorthStar Product Assortment
          </p>

          <h1 className="display-5 fw-bold text-primary mb-3">
            {nsCode}
          </h1>

          <p className="lead text-secondary mx-auto mb-0">
            The products below are included in the{" "}
            <span className="fw-bold text-dark">{nsCode}</span> assortment.
            Product selection may vary based on availability.
          </p>
        </div>

        {/* Existing Product Cards */}
        {matchingItems.length > 0 ? (
          <Row>
            {matchingItems.map((item) => (
              <ProductCard
                key={item.stockNumber}
                item={item}
              />
            ))}
          </Row>
        ) : (
          <div className="text-center py-4">
            <p className="text-muted fs-5 mb-0">
              No standard items were found for{" "}
              <strong>{nsCode}</strong>.
            </p>
          </div>
        )}

        {/* Seasonal NS Group Items */}
        {nsGroup && (
          <>
            <hr className="my-5" />

            <div className="text-center mb-4">
              <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mb-2">
                <h2 className="fw-bold mb-0">
                  Seasonal Products
                </h2>

                <span className="badge bg-warning text-dark fs-6">
                  Call for Availability
                </span>
              </div>
            </div>

            <Row>
              {nsGroup.items.map((item) => (
                <Col
                  key={item.itemNumber}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  className="mt-3 mb-5"
                >
                  <Card className="h-100 shadow">
                    <Card.Img
                      variant="top"
                      src={item.image}
                      alt={item.description}
                      style={{
                        height: "35vh",
                        objectFit: "contain"
                      }}
                    />

                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="fw-bold">
                        {item.description}
                      </Card.Title>

                      <Card.Text className="mt-auto mb-0">
                        <strong>Item Number:</strong>{" "}
                        {item.itemNumber}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Container>
    </main>

    <Footer />
  </div>
);
};

export default NSDetailsPage;
